/* Template: Carousel
   ========================================================================== */

template.component.carousel2 = function() {
	const $carousel = $('.js-gallery-image-carousel');
	const $carouselTabs = $('.js-gallery-navigation-item');
	const activeTabClass = 'js-active';

	const setActiveTab = function(tabIndex) {
		$carouselTabs.removeClass(activeTabClass);
		$carouselTabs.eq(tabIndex).addClass(activeTabClass);
	};

	if ($carousel.length) {
		$carousel.slick({
			autoplay: true,
			prevArrow: '<button class="dc-gallery__control dc-gallery__control--prev js-gallery-prev" type="button"><svg width="27" height="36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M27 31a5 5 0 01-5 5H5a5 5 0 01-5-5V5a5 5 0 015-5h17a5 5 0 015 5v26z" fill="#747879"/><path d="M20.06 5.06a1.5 1.5 0 00-2.12-2.12l2.12 2.12zM5.5 17.5l-1.06-1.06a1.5 1.5 0 000 2.12L5.5 17.5zm12.44 14.56a1.5 1.5 0 002.12-2.12l-2.12 2.12zm0-29.12l-13.5 13.5 2.12 2.12 13.5-13.5-2.12-2.12zM4.44 18.56l13.5 13.5 2.12-2.12-13.5-13.5-2.12 2.12z" fill="#fff"/></svg><span>Prev</span></button>',
			nextArrow: '<button class="dc-gallery__control dc-gallery__control--next js-gallery-next" type="button"><svg width="27" height="36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M27 31a5 5 0 01-5 5H5a5 5 0 01-5-5V5a5 5 0 015-5h17a5 5 0 015 5v26z" fill="#747879"/><path d="M20.06 5.06a1.5 1.5 0 00-2.12-2.12l2.12 2.12zM5.5 17.5l-1.06-1.06a1.5 1.5 0 000 2.12L5.5 17.5zm12.44 14.56a1.5 1.5 0 002.12-2.12l-2.12 2.12zm0-29.12l-13.5 13.5 2.12 2.12 13.5-13.5-2.12-2.12zM4.44 18.56l13.5 13.5 2.12-2.12-13.5-13.5-2.12 2.12z" fill="#fff"/></svg><span>Next</span></button>',
			fade: true,
		});

		$carousel.on('afterChange', function(event, slick, currentSlide) {
			setActiveTab(currentSlide);
		});

		$carouselTabs.on('click', function() {
			const slideIndex = parseInt($carouselTabs.index(this));

			setActiveTab(slideIndex);
			$carousel.slick('slickGoTo', slideIndex, false);
		});
	}
};
